/* First-order LP (page.first-order-lp): scroll reveal, FAQ accordion, smooth scroll to the offer. */
(function () {
  if (window.__sbFoInit) return;
  window.__sbFoInit = true;
  document.documentElement.classList.add('sb-fo-js');

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal() {
    var items = document.querySelectorAll('.sb-fo [data-fo-reveal]:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    items.forEach(function (el) { io.observe(el); });
  }

  function faq(root) {
    root.querySelectorAll('.sb-fo-faq__q').forEach(function (btn) {
      if (btn.__sbFo) return;
      btn.__sbFo = true;
      btn.addEventListener('click', function () {
        var item = btn.closest('.sb-fo-faq__item');
        var open = !item.classList.contains('is-open');
        var list = item.parentElement;
        list.querySelectorAll('.sb-fo-faq__item.is-open').forEach(function (other) {
          if (other === item) return;
          other.classList.remove('is-open');
          other.querySelector('.sb-fo-faq__q').setAttribute('aria-expanded', 'false');
        });
        item.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  function scrollLinks(root) {
    root.querySelectorAll('a[data-fo-scroll]').forEach(function (a) {
      if (a.__sbFo) return;
      a.__sbFo = true;
      a.addEventListener('click', function (e) {
        var id = (a.getAttribute('href') || '').split('#')[1];
        var target = id && document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        var header = document.querySelector('.sb-fo-header');
        var offset = header ? header.offsetHeight : 0;
        var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
      });
    });
  }

  function init(root) {
    reveal();
    faq(root || document);
    scrollLinks(root || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // Theme editor: re-run when a section reloads.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
